import { useEffect } from 'react';
import { FiInfo } from 'react-icons/fi';
import { GoPeople } from 'react-icons/go';

import { LoadWallet } from '../LoadWallet';

import { Button, Card, Divider, Modal } from '@/components';
import { ModalWhatsPins } from '@/components/Team/ModalPinsF11';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import usePinsAccount from '@/hooks/usePinsAccount';
import { TipoProductoTO } from '@/types/myAccount';
import { EnumContextGDT } from '@/types/team';
import { formatToBalanceArs } from '@/utils';

type Props = {
  pinProduct?: TipoProductoTO;
  isPremiumOffer?: boolean;
};

export const Header = ({ isPremiumOffer }: Props) => {
  const { handleSetPinsData, pinsData } = usePinsAccount();
  const { isDesktop } = useIsDesktop();

  const handleTransferirSaldo = () => {
    handleSetPinsData({
      ...pinsData,
      showModalTransferBalance: true,
    });
  };
  useEffect(() => {
    handleSetPinsData({
      ...pinsData,
      showWalletLoadModal: false,
      moneyToWallet: undefined,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCloseModal = () => {
    handleSetPinsData({
      ...pinsData,
      moneyToWallet: pinsData.showPaymentModalMethod
        ? pinsData.moneyToWallet
        : undefined,
      showWalletLoadModal: !!pinsData.showPaymentModalMethod,
      showPaymentModalMethod: pinsData.showWalletLoadModal && false,
    });
  };

  return (
    <>
      <Card className="card--rounded text-left flex w-full justify-between lg:justify-center font-semibold text-gdt-gray-2 !px-6 !py-0 h-[60px] lg:h-[78px] items-center">
        <div className="flex lg:justify-center w-full items-center lg:gap-14">
          <div className="flex gap-2 lg:gap-6">
            <div className="lg:flex justify-between items-center">
              <div className="flex items-center relative lg:gap-0 lg:mr-4 space-x-2 w-20 lg:w-auto">
                <p className="lg:mb-0 mb-[2px] text-3xs lg:text-sm">
                  MIS PINES
                </p>
                <FiInfo
                  className="text-gdt-blue absolute lg:relative lg:right-0 right-[9px] lg:top-0 -top-[2px] cursor-pointer hover:opacity-90"
                  size={18}
                  onClick={() => {
                    handleSetPinsData({
                      ...pinsData,
                      showModalWhatsPins: true,
                    });
                  }}
                />
              </div>
              <span className="font-bold text-gdt-gray-2 text-base lg:text-xl">
                {pinsData.pinsAvailable || 0}
              </span>
            </div>
            <Divider className="h-7" type="vertical" />
            <div className="lg:flex justify-between items-center">
              <div className="flex items-center relative lg:gap-0 lg:mr-4 space-x-2 lg:w-auto w-12">
                <p className="mb-[2px] lg:mb-0 text-3xs lg:text-sm">SALDO</p>
                <FiInfo
                  className="text-gdt-blue absolute lg:relative lg:right-0 right-[-7px] lg:top-0 -top-[2px] cursor-pointer hover:opacity-90"
                  size={18}
                  onClick={() => {
                    handleSetPinsData({
                      ...pinsData,
                      showModalWallet: true,
                    });
                  }}
                />
              </div>
              <span className="font-bold text-gdt-gray-2 text-base lg:text-xl">
                {pinsData.accountMoney !== 0
                  ? `$ ${formatToBalanceArs(pinsData.accountMoney)}`
                  : 0}
              </span>
            </div>
          </div>
          <div className="flex space-x-3 flex-1 lg:flex-none justify-end">
            <Button
              className="py-2 flex items-center gap-x-1 text-xs h-9 lg:h-10"
              disabled={isPremiumOffer}
              href="#"
              type="link"
              variant={'secondary'}
              onClick={() =>
                !isPremiumOffer &&
                handleSetPinsData({
                  ...pinsData,
                  showWalletLoadModal: true,
                })
              }
            >
              {isDesktop && (
                <i className="border rounded-full border-gdt-blue-header h-4 w-4 flex justify-center items-center font-bold not-italic">
                  $
                </i>
              )}
              Cargar Saldo
            </Button>
            {isDesktop && (
              <Button
                className="py-2 flex items-center gap-x-1 text-xs h-9 lg:h-10"
                href="#"
                type="link"
                variant={'secondary'}
                onClick={() => handleTransferirSaldo()}
              >
                {isDesktop && <GoPeople size={17} />}
                <span>Transferir saldo</span>
              </Button>
            )}
          </div>
        </div>
      </Card>
      <ModalWhatsPins context={EnumContextGDT.MyAccount} />

      <Modal
        className="pt-12 pb-9"
        controlledOnClose={() => {
          handleSetPinsData({
            ...pinsData,
            showModalWallet: false,
          });
        }}
        isControlledOpen={Boolean(pinsData.showModalWallet)}
        render={() => {
          return (
            <>
              <h2 className="text-base font-bold text-center">
                ¿Qué es el saldo?
              </h2>
              <p className="mt-4 text-sm font-medium text-center m-auto max-w-[20rem] lg:max-w-[23rem] pb-10">
                Acá ves el saldo disponible en tu cuenta. Podés cargar saldo
                para luego convertirlo al pack de pines que más te convenga.
              </p>
            </>
          );
        }}
        size="xs"
        variant="controlled"
      />
      <Modal
        controlledOnClose={() => {
          handleCloseModal();
        }}
        disableBodyScroll={true}
        isControlledOpen={pinsData.showWalletLoadModal ?? false}
        render={() => <LoadWallet />}
        size="xs"
        title="Cargá saldo en tu cuenta"
        variant="controlled"
      />
    </>
  );
};
